export enum COLUMN_TYPES {
  CY = 'CY',
  PY = 'PY'
}
